<template>
  <div>
    <wc-page-title title='Assign Staff to Routes' :loading='isLoading'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' md='4'>
          <wc-data-box
            hideToolbar
          >
            <v-card-text>
              Assign a lead, vehicle, and optional copilot to each route below.
            </v-card-text>
            <v-form v-model='isFormValid'>
              <v-card flat v-for='(r, index) in routeAssignments' :key='r.id'>
                <v-divider></v-divider>
                <v-card-title>Route {{ index + 1 }}</v-card-title>
                <v-card-subtitle>{{ getRouteDescription(r) }}</v-card-subtitle>
                <v-card-text>
                  <v-autocomplete
                    label='Lead*'
                    :rules='[rules.required]'
                    :items='leads'
                    item-value='id'
                    item-text='name_display'
                    v-model='r.lead'
                  >
                  </v-autocomplete>
                  <v-autocomplete
                    label='Copilot'
                    :items='profiles'
                    item-value='id'
                    item-text='name_display'
                    v-model='r.copilot'
                  >
                  </v-autocomplete>
                  <v-autocomplete
                    label='Vehicle*'
                    :rules='[rules.required]'
                    :items='vehicles'
                    item-value='id'
                    item-text='name'
                    v-model='r.vehicle'
                  >
                  </v-autocomplete>
                </v-card-text>
              </v-card>
            </v-form>
            <v-card-actions>
              <v-btn
                block
                :disabled='!isFormValid'
                depressed
                color='success'
                @click='confirmAssign'
              >Assign these Routes</v-btn>
            </v-card-actions>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>

    <wc-confirm
      :showDialog='showConfirmation'
      :loading='isLoading'
      @cancel='cancelCreate'
      @confirm='createRoutes'
    >
      Are you sure you are ready to generate these routes?<br>
      <br>
      This cannot be undone without the office helping you, so make
      sure you are happy with who is assigned to each route.
    </wc-confirm>
  </div>
</template>

<script>
import scheduleAPI from '@/modules/schedule/api/schedule'
import staffingAPI from '@/modules/staffing/api/staffing'
import vehiclesAPI from '@/modules/assets/api/vehicles'
import formRules from '@/mixins/formRules'
import _ from 'lodash'

export default {
  name: 'setup-routes',
  mixins: [formRules],
  data: () => ({
    isLoading: true,
    isFormValid: false,
    showConfirmation: false,
    routes: [],
    routeAssignments: [],
    profiles: [],
    vehicles: []
  }),
  computed: {
    activeProfiles () {
      return this.profiles.filter(p => p.is_active === true)
    },
    leads () {
      return this.activeProfiles.filter(p => p.can_be_lead === true)
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.routes = await scheduleAPI.getScheduleItemsForSchedule(this.$route.params.id)
      this.routes.forEach(r => {
        this.routeAssignments.push({
          route: r.route_obj.id,
          lead: null,
          copilot: null,
          vehicle: null,
          description: ''
        })
      })
      this.profiles = await staffingAPI.getProfiles()
      this.vehicles = await vehiclesAPI.getVehicles()
      this.isLoading = false
    },
    confirmAssign () {
      this.showConfirmation = true
    },
    cancelCreate () {
      this.isLoading = false
      this.showConfirmation = false
    },
    createRoutes () {
      this.isLoading = true
      let tmp = {}
      // tmp.scheduleID = this.$route.params.id
      tmp.snowTrackerID = this.$route.params.stID
      tmp.routes = _.cloneDeep(this.routeAssignments)
      scheduleAPI.assignRoutes(tmp)
      this.$router.push({ name: 'SnowTrackerDashboard'  })
    },
    getRouteDescription (routeID) {
      let route = this.routes.find(r => r.route === routeID.route)
      return route.route_obj.description
    }
  }
}
</script>
